import { SpView } from 'src/components/SpView';
import { Image, StyleSheet } from 'react-native';
import SpTitle from 'src/components/SpTitle';
import { useTranslation } from 'react-i18next';
import { SpText } from '../../../../components/SpText/SpText';
import colors from '@styles/colors';
import { AppImages } from '@constants/AppImages';
import React from 'react';

const QuickActionsSlide = () => {
  const { t } = useTranslation();
  return (
    <SpView>
      <SpView style={styles.imageWrapper}>
        <Image
          style={{ height: 47, width: 57 }}
          source={AppImages.petHomePaw}
        />
      </SpView>
      <SpTitle
        align="center"
        text={t('quick_actions')}
      />
      <SpText style={styles.contentText}>{t('quick_action_tour_text')}</SpText>
    </SpView>
  );
};

const styles = StyleSheet.create({
  imageWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 40.2,
    marginTop: 32,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 161,
    height: 80,
    backgroundColor: '#263a43',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
    // elevation: 10,
  },
  contentText: {
    fontSize: 16,
    paddingHorizontal: 19,
    lineHeight: 24,
    textAlign: 'center',
    paddingBottom: 24,
    color: colors.greyText.color,
  },
});

export default QuickActionsSlide;
